var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('QuoteForm',{attrs:{"quote":_vm.quoteData,"supplier-product-data":_vm.supplierProductData},on:{"update:quote":_vm.updateQuote,"update:supplier-product-data":_vm.updateSupplierProductData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }